import { useCallback, useEffect, useRef, useState } from 'react';
import { enrichFormElementsWithCustomAttributes, FormElementToolbarItem } from '../utils/FormElementsStore';

const useContactFormToolbarItems = () => {
  const [toolbarItems, setToolbarItems] = useState<FormElementToolbarItem[]>();
  const [toolbarItemsVersion, setToolbarItemsVersion] = useState(0);
  const mounted = useRef(true);

  const refreshToolbarItems = useCallback(async () => {
    const items = await enrichFormElementsWithCustomAttributes();
    if (mounted.current) {
      setToolbarItems(items);
      setToolbarItemsVersion((version) => version + 1);
    }
    return items;
  }, []);

  useEffect(() => {
    mounted.current = true;
    refreshToolbarItems();
    return () => {
      mounted.current = false;
    };
  }, [refreshToolbarItems]);

  return { toolbarItems, refreshToolbarItems, toolbarItemsVersion };
};

export default useContactFormToolbarItems;
